import React from 'react';

export interface SeparatorProps {
    orientation?: 'horizontal' | 'vertical';
    className?: string;
}

const Separator: React.FC<SeparatorProps> = ({ orientation = 'horizontal', className = '' }) => {
    if (orientation === 'vertical') {
        return <div className={`w-px self-stretch bg-slate-100 ${className}`} />;
    }
    return <div className={`h-px w-full bg-slate-100 ${className}`} />;
};

Separator.displayName = 'Separator';
export default Separator;
